import { singleton } from "logic/singleton";
const MAX_ENTRIES = 5e3;
const MAX_CANDIDATES = 5;
const MIN_PARTIAL_MATCH_LENGTH = 3;
const TAG = /<\/?[\w-]+\s*\/?>/g;
export const normalizeText = (text) => text.replace(TAG, "").replace(/\s+/g, " ").trim();
const textsToSources = singleton("i18n.renderedTranslations", () => /* @__PURE__ */ new Map());
const isSameSource = (a, b) => a.namespace === b.namespace && a.key === b.key;
export const recordTranslation = (text, source) => {
  var _a;
  if (typeof text !== "string") {
    return;
  }
  const normalized = normalizeText(text);
  if (!normalized) {
    return;
  }
  const existing = (_a = textsToSources.get(normalized)) != null ? _a : [];
  const sources = [...existing.filter((other) => !isSameSource(other, source)), source];
  textsToSources.delete(normalized);
  textsToSources.set(normalized, sources);
  if (textsToSources.size > MAX_ENTRIES) {
    textsToSources.delete(textsToSources.keys().next().value);
  }
};
export const findTranslations = (text) => {
  const normalized = normalizeText(text);
  if (!normalized) {
    return [];
  }
  const exact = textsToSources.get(normalized);
  if (exact) {
    return exact.map((source) => ({ ...source, text: normalized, exact: true }));
  }
  const partial = [];
  textsToSources.forEach((sources, recorded) => {
    if (recorded.length < MIN_PARTIAL_MATCH_LENGTH) {
      return;
    }
    if (normalized.includes(recorded) || recorded.includes(normalized)) {
      sources.forEach(
        (source) => partial.push({
          ...source,
          text: recorded,
          exact: false,
          distance: Math.abs(recorded.length - normalized.length)
        })
      );
    }
  });
  return partial.sort((a, b) => a.distance - b.distance).filter((candidate, index, all) => all.findIndex((other) => isSameSource(other, candidate)) === index).slice(0, MAX_CANDIDATES).map(({ distance: _distance, ...candidate }) => candidate);
};
export const clearRenderedTranslations = () => textsToSources.clear();
